module.exports = __webpack_public_path__ + "img/HPS022NG.b60485c6.png";